import { render } from "./sidebarpostulante.vue?vue&type=template&id=ff8811b6"
import script from "./sidebarpostulante.vue?vue&type=script&lang=js"
export * from "./sidebarpostulante.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__